import { AutogenLayoutDateRangeMoveWeightDetail } from "./autogen/AutogenLayoutDateRangeMoveWeightDetail";

export class DateRangeMoveWeightDetail extends AutogenLayoutDateRangeMoveWeightDetail {

}